import { SETTINGS_PLUGIN_CHECKOUT_1C_BITRIX_MODULE } from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsPlugins = () => {
    const factory = useSettingsFactory({
        bitrixModuleUrl: { path: SETTINGS_PLUGIN_CHECKOUT_1C_BITRIX_MODULE },
    });

    return {
        bitrixModuleUrl: factory.values.bitrixModuleUrl.value,
        status: factory.status,
        refetch: factory.refetch,
    };
};
